(function () {
  'use strict';

  angular
    .module('app.pages', [
      'app.page-users',
      'app.page-roles',
      'app.page-emails',
      'app.page-maintenances',
      'app.page-maintenance-events',
      'app.page-workgroups',
      'app.page-customers',
      'app.page-orders',
      'app.page-order-tasks',
      'app.page-order-task-types',
      'app.page-system'
    ]);
})();
